import { useRef } from 'react';
import type { MutableRefObject } from 'react';
import { colours } from '@storefront/lib-global/stylings';

export function useLinePositions() {
  const lineRefs = useRef<(HTMLHRElement | null)[]>([]);
  const crossLineRefs = useRef<(HTMLHRElement | null)[]>([]);

  const assignLineRef = (index: number) => (ref: HTMLHRElement | null) => {
    lineRefs.current[index] = ref;
  };

  const assignCrossLineRef = (index: number) => (ref: HTMLHRElement | null) => {
    crossLineRefs.current[index] = ref;
  };

  const updateLinePositions = (refs: MutableRefObject<(HTMLHRElement | null)[]>, inverted = false) => {
    refs.current.forEach((line) => {
      if (line && (!inverted || line.classList.contains('inverted'))) {
        const currentLine = line;
        const listItem = currentLine.parentElement as HTMLElement | null;

        if (listItem) {
          const listItemRect = listItem.getBoundingClientRect();
          const diagonalLength = Math.sqrt(listItemRect.width ** 2 + listItemRect.height ** 2);
          const angle = Math.atan(listItemRect.height / listItemRect.width);
          const rotationDeg = (angle * (inverted ? -180 : 180)) / Math.PI;
          currentLine.style.transform = `translate(-50%, -50%) rotate(${rotationDeg}deg) scaleY(0.8)`;
          currentLine.style.width = `${diagonalLength}px`;
          currentLine.style.borderBottomWidth = '0px';
          currentLine.style.borderTopColor = `${colours.GREY}`;
          currentLine.style.borderTopWidth = '0.5px';
        }
      }
    });
  };

  return { lineRefs, crossLineRefs, assignLineRef, assignCrossLineRef, updateLinePositions };
}
